//src/utils/whatsappOrderMessages.js
export const buildOrderConfirmationWhatsAppMessage = (order) => {
  const firstName = order.customer?.name?.split(" ")[0] || "";

  const itemsText = order.items
    .map(
      (i) =>
        `• ${i.title_en} (${i.quantity} × $${i.price})`
    )
    .join("\n");

  const message = `
Hello ${firstName},

Your order *#${order.orderNumber}* has been confirmed and shipped 🚚✨

Order summary:
${itemsText}

Subtotal: $${order.subtotal.toFixed(2)}
Discount: $${order.discount.toFixed(2)}
Shipping: $${order.shippingCost.toFixed(2)}
Total: $${order.total.toFixed(2)}

Delivery address:
${order.customer.address}

—
مرحباً ${firstName}،

تم تأكيد وشحن طلبك رقم *${order.orderNumber}* 🚚✨

ملخص الطلب:
${itemsText}

الإجمالي: $${order.total.toFixed(2)}

📦 سيتم تسليم الطلب قريباً  
شكراً لتسوقك مع *Esiell* 👟
  `.trim();

  return encodeURIComponent(message);
};
